import { FC } from 'react'
import { CustomSelect, IOption } from '../../../../../../../components/Input/CustomSelect'
import { TableFilter, TableFilters } from '../../../../../../../components/Table/TableFilters'
import { ModeloVersaoLinha } from '../../../../core/_models'

type Props = {
  outrasVersoes: ModeloVersaoLinha[]
  /** Versão escolhida; `undefined` = a publicada (padrão). */
  com?: number
  onChange: (com?: number) => void
}

/** Barra do card: com qual versão do modelo comparar (padrão: a publicada). */
export const ModeloPlataformaComparacaoHeader: FC<Props> = ({ outrasVersoes, com, onChange }) => {
  const opcoes: IOption[] = [
    { label: 'Versão publicada', value: null },
    ...outrasVersoes.map((versao) => ({ label: `Versão ${versao.versao}`, value: versao.id })),
  ]

  return (
    <div className='card-header border-0 pt-6'>
      <TableFilters>
        <TableFilter label='Comparar com' htmlFor='comparar-com' wide>
          <CustomSelect
            inputId='comparar-com'
            options={opcoes}
            value={opcoes.find((opcao) => opcao.value === (com ?? null))}
            onChange={(opcao: IOption | null) =>
              onChange(opcao?.value ? Number(opcao.value) : undefined)
            }
            isClearable={false}
          />
        </TableFilter>
      </TableFilters>
    </div>
  )
}
